import Replicate from 'replicate';
import type { VideoModel } from '.';

const replicateClient = new Replicate({
  auth: process.env.REPLICATE_API_KEY,
  // useFileOutput: false,
});

// TODO: kwaivgi/kling-lip-sync
type KlingModel =
  | 'kwaivgi/kling-v1.6-standard'
  | 'kwaivgi/kling-v1.6-pro'
  | 'kwaivgi/kling-v2.0';

type VeoModel = 'google/veo-3';

type ModelId = KlingModel | VeoModel;

export const replicate: Record<
  string,
  (modelId: ModelId) => VideoModel['model']
> = {
  kling: (modelId: ModelId): VideoModel['model'] => ({
    modelId,
    generate: async ({
      prompt,
      imagePrompt,
      duration,
      aspectRatio,
    }: {
      prompt: string;
      imagePrompt: string | undefined;
      duration: 5;
      aspectRatio: string;
    }) => {
      const output = await replicateClient.run(modelId, {
        input: {
          prompt,
          duration,
          start_image: imagePrompt,
          aspect_ratio: aspectRatio,
        },
      });

      if (!('url' in output) || typeof output.url !== 'function') {
        throw new Error('No output');
      }

      return output.url() as string;
    },
  }),
  veo: (modelId: ModelId): VideoModel['model'] => ({
    modelId,
    generate: async ({
      prompt,
      imagePrompt,
      duration,
      aspectRatio,
    }: {
      prompt: string;
      imagePrompt: string | undefined;
      duration: 5;
      aspectRatio: string;
    }) => {
      const output = await replicateClient.run(modelId, {
        input: {
          prompt,
          duration,
          // start_image: imagePrompt,
          aspect_ratio: aspectRatio,
        },
      });

      if (!('url' in output) || typeof output.url !== 'function') {
        throw new Error('No output');
      }

      return output.url() as string;
    },
  }),
};
